<template>
  <div class="dayWrapper">
    <header>
      <h1>{{ header }}</h1>
      <div class="dayToggle">
        <router-link :to="'/day/' + yesterday" class="material-icons action-icon">
          keyboard_arrow_left
        </router-link>
        <router-link :to="'/day/' + tomorrow" class="material-icons action-icon">
          keyboard_arrow_right
        </router-link>
      </div>
      <!-- TODO - Better styling, please! -->
      <router-link to="edit" class="editLink" append>
        {{ inEditMode ? "&nbsp;" : "EDIT"
        }}<!-- FIXME - Better, please! -->
      </router-link>
    </header>

    <!-- // FIXME - MAKE SURE WE ARE NOT OPERATING IN THE FUTURE -->
    <!-- FIXME - Make sure we're doing something different when the URL changes from date to today -->

    <template v-for="(category, key) in categories" v-if="!category.parentId">
      <div :class="['flexRow category', category.children && category.showChildren ? 'parent' : '']">
        <!-- FIXME - Make this static if we're not in edit mode -->
        <!-- FIXME - IF WE ARE NOT EDITING, HIDE CATEGORIES WITH NO BLOCKS? MAKE THIS A TOGGLE -->
        <category-details-block
          :category="category"
          :completed="getCategoryCompleted(key, date)"
          :quota="getCategoryQuota(key)"
        />

        <!-- FIXME - AT THE VERY LEAST, MOVE QUOTA TO A FUNCTION AND ERROR CHECK PLEASE -->
        <current-blocks
          v-if="inEditMode"
          class="currentBlocks"
          :blocks="getCategoryBlocks(key)"
          :category="category.name"
          :quota="getCategoryQuota(key, date, false)"
          :color="category.color"
          :categoryId="key"
          :isContinuous="inEditMode"
          :customDate="date"
        />
        <static-block-row
          v-else
          :color="category.color"
          :quota="getCategoryQuota(key, date, false)"
          :completed="Object.keys(getCategoryBlocks(key) || {}).length"
        />
      </div>
      <!-- FIXME - THERE HAS TO BE A BETTER WAY TO DO THIS -->
      <template v-if="category.showChildren">
        <div class="flexRow subcategory" v-for="childId in Object.keys(category.children || {})">
          <subcategory-details-block :categoryId="childId" />
          <current-blocks
            v-if="inEditMode"
            class="currentBlocks"
            :blocks="isToday ? categories[childId].blocks : blocks[childId]"
            :category="categories[childId].name"
            :quota="getCategoryQuota(childId, date, false)"
            :color="categories[childId].color"
            :categoryId="childId"
            :isContinuous="inEditMode"
            :customDate="date"
          />
          <static-block-row
            v-else
            :color="categories[childId].color"
            :quota="getCategoryQuota(childId, date, false)"
            :completed="Object.keys((isToday ? categories[childId].blocks : blocks[childId]) || {}).length"
          />
        </div>
      </template>
    </template>
  </div>
</template>

<script>
// TODO - Edit category?
// TODO - Different layouts?

import CurrentBlocks from "../components/CurrentBlocks.vue";
import StaticBlockRow from "../components/StaticBlockRow.vue";
import CategoryDetailsBlock from "../components/CategoryDetailsBlock.vue";
import SubcategoryDetailsBlock from "../components/SubcategoryDetailsBlock.vue";
import NewBlock from "../components/NewBlock.vue";

import db from "../db.js";
import util from "../util.js";
import categoryUtil from "../categoryUtil.js";

export default {
  name: "day-view",
  mixins: [categoryUtil.getMixin()],
  components: {
    "current-blocks": CurrentBlocks,
    "category-details-block": CategoryDetailsBlock,
    "subcategory-details-block": SubcategoryDetailsBlock,
    "static-block-row": StaticBlockRow,
    "new-block": NewBlock,
  },
  props: ["categories"],
  data() {
    return {
      blocks: {},
      date: "",
    };
  },
  watch: {
    $route: "loadData",
  },
  created() {
    this.loadData();
  },
  destroyed() {
    //FIXME - Add error checking/validation of the date here, please!
    if (!this.isToday) {
      db.stopListeningDay(this.date);
    }
  },
  methods: {
    loadData() {
      //FIXME - Add error checking here, please!
      this.$set(this, "date", this.$route.params.date || util.getCurrentDay());

      // FIXME - MAKE SURE WE ARE NOT OPERATING IN THE FUTURE

      if (this.isToday) {
        return;
      }
      //FIXME - Add error checking/validation of the date here, please!
      db.loadAndListenDay(this.date, data => {
        this.$set(this, "blocks", data ? data : {});
      });
    },
    getCategoryBlocks(id) {
      const category = categoryUtil.getCategory(id);
      const showChildren = categoryUtil.getShowChildren(id);

      if (this.isToday) {
        return !showChildren ? category.totalBlocks : category.blocks;
      }

      if (showChildren) {
        return this.blocks[id];
      }

      let totalBlocks = Object.assign({}, this.blocks[id]);
      Object.keys(category.children || {}).forEach(childId => {
        Object.assign(totalBlocks, this.blocks[childId]);
      });

      return totalBlocks;
    },
  },
  computed: {
    header() {
      return this.isToday ? "Today" : moment(this.date, util.dateString).format("MMMM Do, YYYY");
    },
    isToday() {
      return this.date ? this.date == util.getCurrentDay() : true;
    },
    inEditMode() {
      return this.$route.params.mode == "edit" || this.isToday;
    },
    yesterday() {
      return moment(this.date, util.dateString)
        .subtract(1, "day")
        .format(util.dateString);
    },
    tomorrow() {
      return moment(this.date, util.dateString)
        .add(1, "day")
        .format(util.dateString);
    },
  },
};
</script>

<style>
/*.parent .blockRow {
  padding-bottom: 0.125rem;
}*/

.subcategory .blockRow {
  padding: 0.125rem;
  padding-left: 0.75rem;
}

a.material-icons.action-icon {
  text-decoration: none;
  color: inherit;
}
</style>

<style scoped>
.dayWrapper {
  max-width: 600px;
  margin: auto;
}

.currentBlocks.flexRow {
  max-width: 65%; /* FIXME - This should be something other than percentages */
}

.flexRow.category {
  margin: 0.75rem;
  /*align-items: baseline;*/
}

.flexRow.category.parent {
  margin-bottom: 0;
}

.flexRow.subcategory {
  margin: 0 0.75rem;
}

.editLink {
  font-size: 0.75rem;
  text-decoration: none;
  cursor: pointer;
  color: #ccc;
}

.editLink:hover {
  color: #3498db;
}

.dayToggle > a {
  margin: 0 0.75rem;
}

@media (max-width: 600px) {
  .flexRow.category {
    margin: 0.25rem;
  }
}
</style>



// WEBPACK FOOTER //
// DayView.vue?5dcbedac